export default "__VITE_ASSET__BTjyBx0W__"